var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data"},[_c('img',{attrs:{"src":_vm.nullBg,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"no-data-tip"},[_vm._v("暂无数据")])])}
var staticRenderFns = []

export { render, staticRenderFns }